module.exports = __webpack_public_path__ + "assets/img/wg-3.dc30ee25.jpg";